import React from "react";
import ToolsGrid from "../components/ToolsGrid";
import { useSEO } from "../hooks/useSEO";

export default function Home() {
  useSEO({
    title: null, // Utilise le titre par défaut
    description: "Calculez gratuitement votre mensualité de crédit immobilier, frais de notaire, capacité d'emprunt, rentabilité locative et plus-value. Outils 100% gratuits et sans inscription."
  });

  return (
    <div style={{ maxWidth: 1100, margin: "0 auto", padding: 16 }}>
      <h1 style={{ marginBottom: 8 }}>Outils Immobilier gratuits</h1>
      <p style={{ marginTop: 0, opacity: 0.75 }}>
        Simulateurs et documents utiles : achat, investissement, vente.
      </p>

      <ToolsGrid />
    </div>
  );
}
